<template>
  <div class="alerte px-5 text-center">
    <v-alert type="error">
      {{ message }}
    </v-alert>
    <AgrButton
      class="ma-5"
      @click="reload()"
    >
      <v-icon>mdi-refresh</v-icon>
      Réessayer
    </AgrButton>
  </div>
</template>

<script>
import { AgrButton } from '@agrial/ui'

export default {
  name: 'BaseErrorMessage',
  components: { AgrButton },
  props: {
    message: {
      type: String,
      required: true
    }
  },
  methods: {
    reload () {
      this.$emit('reload')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
